module.exports = __webpack_public_path__ + "media/images/awards-1-f651cff3107316908d917e0b77264dbe.jpg";